exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Carousel-module__wrapper___3QiY4{position:relative;min-height:450px;overflow:hidden;margin-bottom:1em}.Carousel-module__wrapper___3QiY4 img{height:450px;width:100%;position:absolute;-o-object-fit:cover;object-fit:cover;-o-object-position:center;object-position:center;border-radius:5px}", ""]);

// exports
exports.locals = {
	"wrapper": "Carousel-module__wrapper___3QiY4"
};